<template>
  <div>
    <basic-container v-loading="loading">
      <h3 class="title mB-30">供应链服务协议</h3>
      <div v-if="appointBaseInfo || (tableData && tableData.length)">
        <div class="basic" v-if="appointBaseInfo">
          <h4 class="mT-30 mB-20">基本信息</h4>
          <table v-if="appointBaseInfo">
              <tr>
                <td>协议编号</td>
                <td>{{appointBaseInfo.appointNo || ''}}</td>
                <td>生效日期</td>
                <td>{{appointBaseInfo.startTime || ''}}</td>
              </tr>
              <tr>
                <td>生效日期</td>
                <td>{{appointBaseInfo.endTime || ''}}</td>
                <td></td>
                <td></td>
              </tr>
          </table>  
        </div>

        <h4 class="mT-30 mB-20">商品信息</h4>
        <el-table :data="tableData">
          <el-table-column label="编号" type="index" align="center" width="65" />
          <el-table-column label="SKU-ID" prop="skuId" align="center" />
          <el-table-column label="SKU 名称" prop="skuName" align="center" />
          <el-table-column label="协议量" prop="appointStock" align="center" /> 
        </el-table>
        <div class="footer">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="formData.page"
            :page-size.sync="formData.size"
            :page-sizes="[20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total.sync="total"
            background
          />
        </div>
      </div>
    </basic-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        page: 1,
        size: 20
      },
      total: 0,
      tableData: [],
      appointBaseInfo: null,
      loading: false
    }
  },
  mounted() {
    this.getBaseInfo()
    this.search()
  },
  methods: {
    async getBaseInfo () {
      const res = await _api.appoint.getAppointBaseInfoById({
        appointNo: this.$route.query.appointNo
      })
      if (!res || !res.ret || !res.data) {
        return
      }
      this.appointBaseInfo = res.data
    },
    search() {
      this.formData.page = 1
      this.getAppointGoodsList()
    },
    async getAppointGoodsList() {
      this.loading = true
      const res = await _api.appoint.getAppointGoodsList({
        appointNo: this.$route.query.appointNo
      })
      this.loading = false
      if (!res || !res.ret || !res.data) {
        this.tableData = []
        this.total = total
        return
      }
      const { data, total } = res.data
      this.tableData = data || []
      this.total = total
    },
    handleSizeChange(val) {
      this.formData.page = 1
      this.getAppointGoodsList()
    },
    handleCurrentChange(val) {
      this.getAppointGoodsList()
    }
  }
}
</script>

<style lang="scss">

.title {
  font-size: 16px;
  color: #409eff;
}

.basic {

  table {
     width: 100%;
     border-spacing: 0;
     border-collapse: collapse;
     border: 1px solid #C0C0C0;
  }
  table td {
    border: 1px solid #C0C0C0;
  }
  table tr td:nth-child(odd) {
    width: 100px;
    padding: 10px 10px;
    background-color: #dddddd;

    font-size: 13px;
    font-weight: bold;
  }

  table tr td:nth-child(even) {
    width: 200px;
    padding: 10px 10px;
  }
}
</style>